import { render, staticRenderFns } from "./AutoSave.vue?vue&type=template&id=50900053&scoped=true"
import script from "./AutoSave.vue?vue&type=script&lang=js"
export * from "./AutoSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50900053",
  null
  
)

export default component.exports